export default __webpack_public_path__ + "static/media/img11.3dac90dc.png";